<app-header4></app-header4>
<!--====== BANNER PART START ======-->
<div class="banner-active bg_cover" style="background-image: url(assets/images/imagesAssets/image2.jpg)">
    <div class="single-banner c-ma">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="banner-content">
                            <span class="c-textisn" data-animation="fadeInLeft" data-delay="0.5s">ISN POLYSCIENCE</span>
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title">Institut des Sciences<br> Novatrices</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="single-banner bg_cover c-ma" style="background-image: url(assets/images/imagesAssets/image1re.jpg)">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="banner-content">
                            <span class="c-textisn" data-animation="fadeInLeft" data-delay="0.5s">ISN POLYSCIENCE</span>
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title">Institut des Sciences<br> Novatrices</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="single-banner bg_cover c-ma" style="background-image: url(assets/images/imagesAssets/technique.jpg)">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="banner-content">
                            <span class="c-textisn" data-animation="fadeInLeft" data-delay="0.5s">ISN POLYSCIENCE</span>
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title">Institut des Sciences<br> Novatrices</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== BANNER PART ENDS ======-->
<!--====== WHO WE ARE PART START ======-->

<div class="about-area pt-90 pb-120 c-backArrea">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 order-2 order-lg-1">
                <div class="about-thumb mt-30">
                    <img class="c-im" src="assets/images/imagesAssets/apropos.png" alt="">
                </div>
            </div>
            <div class="col-lg-6 col-md-12 order-1 order-lg-2">
                <div class="about-item mt-30">
                    <span>Présentation</span>
                    <h3 class="title c-motPresi">ISN POLYSCIENCE.</h3>
                    <p class="c-textPresi">
                        Notre Institut tient sa raison d’être de la transformation de la formation professionnelle en Afrique. <br> Cette volonté de transformation émane d’une étude de l’UNESCO qui, après avoir établi que 20% des populations africaines
                        sont constituées de jeunes âgés entre 15 et 24 ans, a aussi révélé que 40% de cette catégorie sociale est au chômage. La raison c’est l’inadéquation entre l’offre de formations et la demande des employeurs. <br> Par ailleurs, les
                        projections promettent 100 millions de jeunes dans le marché du travail d’ici 2030, et si rien n’est fait, les gouvernements africains auront à gérer des taux de chômage jamais connus et feront sûrement face à des crises sociales
                        avec comme catalyseurs les réseaux d’émigration clandestine. <br> Conscients de ces enjeux, les 8 pays de l’UEMOA ont entamé depuis 2017 une mutualisation de leurs forces par le partage des curricula de leurs programmes d’Enseignement
                        et Formations Techniques et Professionnelles (EFTP) et des référentiels métiers. ISN POLYSCIENCE s’inscrit donc dans cette dynamique et propose des profils de formations conformes aux référentiels adoptés au sein de l’UEMOA, souvent
                        même de la CEDEAO et notamment dans des sciences innovantes (voir les différentes sections de formations).

                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- statistique section -->
<section class="counter-section secondary-bg pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6 wow fadeInLeft" data-wow-delay="0.3s" *ngFor="let item of counterblock;let i = index">
                <div class="counter-box " [ngClass]="item.id === 2 ? 'mt-40 mb-xs-gap-40':'' || item.id === 4 ? 'mt-40':''">
                    <div class="icon"><img [src]="item.icon"></div>
                    <span class="counter">{{item.value}}</span>
                    <h6 class="title">{{item.title}}</h6>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end statistique section -->



<div class="who-we-are-area pt-110 pb-120">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0s">
                <div class="section-title">
                    <span class="c-section">Sections</span>
                    <h2 class="title c-diffSection">Nos différentes Sections</h2>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1 wow fadeInRight" data-wow-duration="1.5s" data-wow-delay="0s">
                <div class="section-title">
                    <p class="c-textPresi">L'ISN POLYSCIENCE est fondé par l'initiative de l'ancien Directeur des Etudes de l'Institut Panafricain de Formation avec l'implication de professeurs attitrés ayant déja offert des prestations de haute qualité à l'université Cheikh
                        Anta DIOP et dans les autres établissements privés de formation en santé. A travers un enseignement de qualité et novateur afin de faciliter l’insertion dans le monde professionnel, l'ISN POLYSCIENCE propose une offre de formation
                        dans plusieurs domaines. </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration=".5s" data-wow-delay="0s" routerLink="/sante">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/nursing.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION SOINS INFIRMIERS ET OBSTETRIQUES</h5>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration="1s" data-wow-delay="0s" routerLink="/sante">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/organic.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION GENIE BIOLOGIQUE</h5>
                    <br>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration="1.5s" data-wow-delay="0s" routerLink="/sante">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/environmental-protection.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION HYGIENE, SECURITE QUALITE, ENVIRONNEMENT</h5>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration="2s" data-wow-delay="0s" routerLink="/techniqueGestion">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/settings.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION GENIE INFORMATIQUE</h5>
                    <br>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration="2s" data-wow-delay="0s" routerLink="/techniqueGestion">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/plug.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION GENIE ELECTRIQUE</h5>
                    <br>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 wow slideInUp c-pointer" data-wow-duration="2s" data-wow-delay="0s" routerLink="/techniqueGestion">
                <div class="what-we-do-item text-center mt-30 c-border">
                    <img src="assets/images/imagesAssets/accounting.png" class="c-image_iconPole" alt="">
                    <h5 class="title c-textTitre">SECTION GESTION</h5>
                    <br>
                    <a><i class="fal fa-long-arrow-right"></i></a>
                </div>
            </div>
        </div>
    </div>
    <div class="what-we-are-shape-1">
        <img src="assets/images/what-we-are-shape-1.png" alt="shape">
    </div>
    <div class="what-we-are-shape-2">
        <img src="assets/images/what-we-are-shape-2.png" alt="shape">
    </div>
</div>

<!--====== WHO WE ARE PART ENDS ======-->
<!--====== SOLUTION PART START ======-->
<div class="solution-area bg_cover" style="background-image: url(assets/images/imagesAssets/test.jpg);">
    <div class="solution-overlay pt-120">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="solution-box">
                        <div class="solution-content">
                            <h3 class="title">LES INSCRIPTIONS ONT DEMARRE DEPUIS LE 20 SEPTEMBRE 2021</h3>
                            <div class="solution-play text-right mr-30 d-block d-lg-none">
                                <a class="video-popup" href="http://bit.ly/2VuPnrx"><i class="fas fa-play"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="solution-play text-right mr-30 d-none d-lg-block">
                        <a class="video-popup" href="http://bit.ly/2VuPnrx"><i class="fas fa-play"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== SOLUTION PART ENDS ======-->
<!--====== LATEST SERVICES PART START ======-->
<div class="latest-services-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration=".5s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/infirmier.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Infirmiers d’Etat</h4>
                        <p>Un infirmier est un professionnel de santé, spécialisé dans les soins après une opération. Il agit en étroite collaboration avec les professions médicaux.</p>
                        <a (click)="admissionMaster('INFIRMIER')">Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/biologie.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Licence Biologie médicale</h4>
                        <p>Le biologiste médical réalise et contrôle la réalisation d’actes de biologie médicale, il interprète et valide ensuite les résultats afin...</p>
                        <a (click)="admissionMaster('GENIE-BIOLOGIQUE')">Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/qualite.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Licence Hygiène, Sécurité et Environnement</h4>
                        <p>La licence QHSE vise la mise en œuvre et l’animation des démarches dans les domaines de la qualité, de l’hygiène...</p>
                        <a routerLink='/'>Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration="2s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/indusO.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Licence en Informatique et Réseaux Industriels</h4>
                        <p>Cette formation vise à former des cadres possédant les savoirs fondamentaux, les compétences technologiques et les outils/méthodes nécessaires à la définition, à la mise en oeuvre et au développement de procédés dans les domaines
                            de la micro-informatique et l’informatique industrielle</p>
                        <a (click)="admissionMaster('InformatiqueReseauxIndustriel')">Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration="2.5s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/electro.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Licence Electromécanique</h4>
                        <p>La Licence Électromécanique forme des collaborateurs spécialisés en amélioration des systèmes industriels. Les entreprises concernées sont aussi bien des PME-PMI, que les grands groupes dans des domaines très variés : industrie
                            de la mécanique, plasturgie, pétrochimie…</p>
                        <a>Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-9 wow fadeInUp" data-wow-duration="3s" data-wow-delay="0s">
                <div class="single-services mt-30 mb-55">
                    <div class="services-thumb">
                        <img class="immB" src="assets/images/imagesAssets/bien.jpg" alt="">
                    </div>
                    <div class="services-content">
                        <h4 class="title">Licence Gestion et Administration des Biens</h4>
                        <p>L’objectif de cette licence est d’assurer la formation des administrateurs de biens du secteur privé au sens larges : agent immobilier, gestionnaire locatif et syndic. Ce professionnel vend ou gère des biens immobiliers en copropriété...</p>
                        <br>
                        <a (click)="admissionMaster('GestionAdministrationBien')">Voir Plus <i class="fal fa-long-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--====== LATEST SERVICES PART ENDS ======-->
<!--====== MEET US PART ENDS ======-->
<div class="action-area mtArre">
    <div class="action-overlay bg_cover" style="background-image: url(assets/images/imagesAssets/bannerBien.jpg);">
        <div class="container">
            <div class="action-bg">
                <div class="row align-items-center">
                    <div class="col-lg-8">
                        <div class="action-content">
                            <span>BIENVENUE À L'ISN POLYSCIENCE</span>
                            <h3 class="title c-TitleFor">Plus qu'une Formation, un Avenir à Construire.</h3>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="action-btn text-left text-lg-right">
                            <a class="main-btn c-btnConta" routerLink='/contact-isn'><i class="fal fa-comments"></i> Contactez-Nous</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contact and email -->
<div class="action-2-area bg_cover c-Conta" style="background-image: url(assets/images/action-bg.jpg);">
    <div class="action-overlay">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4">
                    <div class="action-item mt-30">
                        <span>Pour plus de renseignements.</span>
                        <h2 class="title c-titleContact">CONTACTEZ-NOUS.</h2>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="action-support d-flex mt-30">
                        <div class="action-support-item wow bounceInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                            <p>Email</p>
                            <span>isninfo@isn.sn</span>
                            <i class="fal fa-envelope"></i>
                        </div>
                        <div class="action-support-item action-support-item-2 wow bounceInUp" data-wow-duration=".7s" data-wow-delay=".7s">
                            <p>Téléphone</p>
                            <span>78 559 86 30 | 77 649 19 12 | 77 574 56 67</span>
                            <i class="fal fa-phone"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end Contact and email -->


<div class="brand-2-area pbPartenaire">
    <div class="container">
        <div class="row">
            <h2 class="c-partenaireh1">Nos Partenaires</h2>
            <div class="col-lg-12">
                <div class="brand-active">
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/cames_1.png" alt="brand name">
                    </div>
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/uv-ucad_1.png" alt="brand name">
                    </div>
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/uv-thies_1.png" alt="brand name">
                    </div>
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/uv-gaston_1.png" alt="brand name">
                    </div>
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/uv-bambey_1.png" alt="brand name">
                    </div>
                    <div class="brand-item">
                        <img src="assets/images/imagesAssets/uv-ussein_1.png" alt="brand name">
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<app-footer2></app-footer2>